import type { RouteObject } from "react-router-dom"
import Home from "@/pages/Home"
import AdminLogin from "@/pages/AdminLogin"
import AdminOrders from "@/pages/AdminOrders"
import { Toaster } from "react-hot-toast"
import { useRoutes } from "react-router-dom"

export const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/admin/login", element: <AdminLogin /> },
  { path: "/admin", element: <AdminOrders /> },
]

function App() {
  const element = useRoutes(routes)
  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#2b4456",
            color: "#fff",
            fontSize: "13px",
            letterSpacing: "0.08em",
          },
        }}
      />
      {element}
    </>
  )
}

export default App
